/* bk-merken.js – Merkzettel und Produktvergleich (18.10.2026).
   Gespeichert wird nur im Browser des Besuchers (localStorage, Produkt-Handles) – kein Konto, nichts an Dritte.
   Knöpfe: <button data-bk-merken="handle"> und <button data-bk-vergleich="handle"> (snippets/merken-knoepfe.liquid).
   Seiten: /collections/all?view=merkzettel und ?view=vergleich (templates/collection.merkzettel|vergleich.json,
   sections/main-merkliste.liquid mit #bk-merkliste[data-modus]). Unten links eine schwebende Leiste, sobald etwas gespeichert ist. */
(function () {
  var MAX_VERGLEICH = 4;
  var LISTEN = { merken: 'bk_merkzettel', vergleich: 'bk_vergleich' };

  function lesen(liste) { try { return JSON.parse(localStorage.getItem(LISTEN[liste]) || '[]'); } catch (e) { return []; } }
  function schreiben(liste, werte) { try { localStorage.setItem(LISTEN[liste], JSON.stringify(werte)); } catch (e) {} }
  function enthaelt(liste, h) { return lesen(liste).indexOf(h) !== -1; }

  function umschalten(liste, h) {
    var w = lesen(liste), i = w.indexOf(h);
    if (i !== -1) { w.splice(i, 1); }
    else {
      if (liste === 'vergleich' && w.length >= MAX_VERGLEICH) { hinweis('Sie können bis zu ' + MAX_VERGLEICH + ' Produkte vergleichen. Entfernen Sie zuerst eines.'); return; }
      w.push(h);
    }
    schreiben(liste, w);
    aktualisieren();
  }

  function hinweis(text) {
    var el = document.getElementById('bk-merk-hinweis');
    if (!el) { el = document.createElement('div'); el.id = 'bk-merk-hinweis'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = text; el.classList.add('sichtbar');
    clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('sichtbar'); }, 3200);
  }

  /* Knöpfe und Leiste auf den aktuellen Stand bringen */
  function aktualisieren() {
    document.querySelectorAll('[data-bk-merken]').forEach(function (b) {
      var an = enthaelt('merken', b.getAttribute('data-bk-merken'));
      b.classList.toggle('ist-an', an); b.setAttribute('aria-pressed', an ? 'true' : 'false');
      var t = b.querySelector('.bk-mk__text'); if (t) t.textContent = an ? 'Gemerkt' : 'Merken';
    });
    document.querySelectorAll('[data-bk-vergleich]').forEach(function (b) {
      var an = enthaelt('vergleich', b.getAttribute('data-bk-vergleich'));
      b.classList.toggle('ist-an', an); b.setAttribute('aria-pressed', an ? 'true' : 'false');
      var t = b.querySelector('.bk-mk__text'); if (t) t.textContent = an ? 'Im Vergleich' : 'Vergleichen';
    });
    leiste();
  }

  function leiste() {
    var m = lesen('merken').length, v = lesen('vergleich').length;
    /* Herz in der gescrollten Kopfleiste (snippets/site-header.liquid): Zahl und Ansage für Screenreader */
    document.querySelectorAll('.bk-merk-btn').forEach(function (a) {
      var z = a.querySelector('.bk-merk-count'); if (z) z.textContent = m ? String(m) : '';
      a.setAttribute('aria-label', m ? 'Merkzettel: ' + m + (m === 1 ? ' Produkt' : ' Produkte') : 'Merkzettel');
    });
    var el = document.getElementById('bk-merkleiste');
    if (!m && !v) { if (el) el.remove(); return; }
    if (!el) { el = document.createElement('nav'); el.id = 'bk-merkleiste'; el.setAttribute('aria-label', 'Merkzettel und Vergleich'); document.body.appendChild(el); }
    var html = '';
    if (m) html += '<a href="/collections/all?view=merkzettel">♡ Merkzettel <b>' + m + '</b></a>';
    if (v) html += '<a href="/collections/all?view=vergleich">⇄ Vergleichen <b>' + v + '</b></a>';
    el.innerHTML = html;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bk-merken],[data-bk-vergleich]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.hasAttribute('data-bk-merken')) umschalten('merken', b.getAttribute('data-bk-merken'));
    else umschalten('vergleich', b.getAttribute('data-bk-vergleich'));
    if (document.getElementById('bk-merkliste')) seite();
  });

  /* ---------- Merkzettel- und Vergleichsseite ---------- */
  function geld(cent) { return (cent / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
  function bild(url, breite) { if (!url) return ''; var u = url.indexOf('//') === 0 ? 'https:' + url : url; return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + breite; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* Merkmale aus den Filter-Tags – gleiche Bedeutung wie snippets/produkt-daten.liquid */
  function merkmale(p) {
    var t = { personen: [], innen: [], masse: [], kw: [], farbe: [], antrieb: [] };
    (p.tags || []).forEach(function (tag) {
      var m = tag.match(/^(personen|innenmass|masse|ofenkw|farbe|antrieb):(.+)$/);
      if (!m) return;
      var k = { personen: 'personen', innenmass: 'innen', masse: 'masse', ofenkw: 'kw', farbe: 'farbe', antrieb: 'antrieb' }[m[1]];
      if (t[k].indexOf(m[2]) === -1) t[k].push(m[2]);
    });
    var pers = t.personen.map(Number).sort(function (a, b) { return a - b; });
    var kw = t.kw.map(Number).sort(function (a, b) { return a - b; });
    var masse = t.masse.map(function (x) { var mm = x.split('x'); return (mm.length === 2 && mm[0].length === 4) ? Math.round(mm[0] / 10) + ' × ' + Math.round(mm[1] / 10) + ' cm' : x.replace('x', ' × ').replace('m', ' m'); });
    return {
      'Kategorie': p.type || '–',
      'Marke': (p.vendor && p.vendor !== 'bretterkiste') ? p.vendor : '–',
      'Personen': pers.length ? (pers.length > 1 ? pers[0] + '–' + pers[pers.length - 1] : pers[0]) + ' Personen' : '–',
      'Innenmaße': t.innen.length ? t.innen.map(function (x) { return x.replace('cm', ' cm'); }).join(', ') : '–',
      'Außenmaße': masse.length ? masse.join(', ') : '–',
      'Ofenleistung': kw.length ? (kw.length > 1 ? String(kw[0]).replace('.', ',') + '–' + String(kw[kw.length - 1]).replace('.', ',') : String(kw[0]).replace('.', ',')) + ' kW' : '–',
      'Farben': t.farbe.length ? t.farbe.map(function (f) { f = f.replace('weiss', 'weiß'); return f.charAt(0).toUpperCase() + f.slice(1); }).join(', ') : '–',
      'Antrieb': t.antrieb.length ? t.antrieb[0].charAt(0).toUpperCase() + t.antrieb[0].slice(1) : '–',
      'Ausführungen': p.variants ? p.variants.length : '–'
    };
  }

  function preis(p) {
    if ((p.tags || []).indexOf('preis:anfrage') !== -1) return 'Preis auf Anfrage';
    return (p.price_varies ? 'ab ' : '') + geld(p.price_min);
  }

  function laden(handles) {
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (liste) { return liste.filter(Boolean); });
  }

  function seite() {
    var app = document.getElementById('bk-merkliste');
    if (!app) return;
    var modus = app.getAttribute('data-modus');
    var handles = lesen(modus === 'vergleich' ? 'vergleich' : 'merken');
    var ziel = app.querySelector('.bk-ml__inhalt');
    if (!handles.length) {
      ziel.innerHTML = '<p class="bk-ml__leer">' + (modus === 'vergleich'
        ? 'Noch keine Produkte im Vergleich. Klicken Sie auf einer Produktseite oder Produktkarte auf „⇄ Vergleichen“ (bis zu ' + MAX_VERGLEICH + ' Produkte).'
        : 'Ihr Merkzettel ist leer. Klicken Sie auf einer Produktseite oder Produktkarte auf „♡ Merken“.') +
        '</p><p class="bk-ml__leer"><a href="/collections/saunen">Saunen ansehen</a> · <a href="/collections/whirlpools">Whirlpools ansehen</a></p>';
      return;
    }
    ziel.innerHTML = '<p class="bk-ml__leer">Wird geladen …</p>';
    laden(handles).then(function (produkte) {
      if (modus === 'vergleich') {
        var daten = produkte.map(merkmale);
        var zeilen = Object.keys(daten[0] || {}).filter(function (k) { return daten.some(function (d) { return d[k] !== '–'; }); });
        var html = '<div class="bk-vg__scroll"><table class="bk-vg"><thead><tr><th></th>';
        produkte.forEach(function (p) {
          html += '<th><a href="' + esc(p.url) + '" class="bk-vg__kopf">' + (p.featured_image ? '<img src="' + esc(bild(p.featured_image, 300)) + '" alt="" loading="lazy">' : '') +
            '<span>' + esc(p.title) + '</span></a><button type="button" class="bk-vg__weg" data-bk-vergleich="' + esc(p.handle) + '" aria-label="' + esc(p.title) + ' aus dem Vergleich entfernen">Entfernen</button></th>';
        });
        html += '</tr></thead><tbody><tr><th>Preis</th>' + produkte.map(function (p) { return '<td class="bk-vg__preis">' + preis(p) + '</td>'; }).join('') + '</tr>';
        zeilen.forEach(function (k) { html += '<tr><th>' + k + '</th>' + daten.map(function (d) { return '<td>' + esc(d[k]) + '</td>'; }).join('') + '</tr>'; });
        html += '<tr><th></th>' + produkte.map(function (p) { return '<td><a class="bk-vg__los" href="' + esc(p.url) + '">Zum Produkt</a></td>'; }).join('') + '</tr></tbody></table></div>';
        ziel.innerHTML = html;
      } else {
        ziel.innerHTML = '<div class="bk-ml__raster">' + produkte.map(function (p) {
          return '<div class="bk-ml__karte"><a href="' + esc(p.url) + '"><div class="bk-ml__bild">' + (p.featured_image ? '<img src="' + esc(bild(p.featured_image, 400)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</div>' +
            '<div class="bk-ml__titel">' + esc(p.title) + '</div><div class="bk-ml__preis">' + preis(p) + '</div></a>' +
            '<div class="bk-ml__aktionen"><button type="button" class="bk-mk bk-mk--klein" data-bk-vergleich="' + esc(p.handle) + '"><span class="bk-mk__text">Vergleichen</span></button>' +
            '<button type="button" class="bk-ml__weg" data-bk-merken="' + esc(p.handle) + '">Entfernen</button></div></div>';
        }).join('') + '</div>';
      }
      aktualisieren();
    });
  }

  function start() { aktualisieren(); seite(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  /* Änderungen aus anderem Tab übernehmen */
  window.addEventListener('storage', function (e) { if (e.key === LISTEN.merken || e.key === LISTEN.vergleich) start(); });
})();
